import React, {forwardRef} from 'react';

import {IconProps} from './types';

const LockIcon = forwardRef<HTMLOrSVGElement, IconProps>(
    ({size = 20, ...props}: IconProps, ref) => (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" ref={ref} {...props}>
            <path
                d="M9.00014 2.875C7.30707 2.875 5.93457 4.2475 5.93457 5.94057H3.93457C3.93457
             3.14293 6.2025 0.875 9.00014 0.875C11.7978 0.875 14.0657 3.14293 14.0657 5.94057H12.0657C12.0657
              4.2475 10.6932 2.875 9.00014
               2.875ZM3.93457 8.25H2.25V17.25H15.75V8.25H14.0657V5.94067H12.0657V8.25H5.93457V5.94067H3.93457V8.25Z"
            />
        </svg>
    )
);

export default LockIcon;
